import createIcon from '../../createIcon';

/**
 * @component @name Man3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgNy4xMjM2OEgxMEM4LjkgNy4xMjM2OCA4IDguMDIzNjggOCA5LjEyMzY4VjE1LjEyMzdIMTBWMjIuMTIzN0gxNFYxNS4xMjM3SDE2VjkuMTIzNjhDMTYgOC4wMjM2OCAxNS4xIDcuMTIzNjggMTQgNy4xMjM2OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC4yNDg1IDQuMTIzNThMMTEuOTk5OSAxLjg3NUw5Ljc1MTMyIDQuMTIzNThMMTEuOTk5OSA2LjM3MjE2TDE0LjI0ODUgNC4xMjM1OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Man3 = createIcon('Man3', [
  [
    'path',
    {
      d: 'M14 7.12368H10C8.9 7.12368 8 8.02368 8 9.12368V15.1237H10V22.1237H14V15.1237H16V9.12368C16 8.02368 15.1 7.12368 14 7.12368Z',
      key: '1gpkq6',
    },
  ],
  [
    'path',
    {
      d: 'M14.2485 4.12358L11.9999 1.875L9.75132 4.12358L11.9999 6.37216L14.2485 4.12358Z',
      key: 'jimx31',
    },
  ],
]);

export default Man3;
